import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Container, Row, Col } from 'reactstrap';

const KTSubStudy = () => {
    return (
        <React.Fragment>
            <HeightDiv>
                <ParentDiv>
                    <StyledBackgroundImage />
                </ParentDiv>
            </HeightDiv>
            <Container fluid={true}>
                <Row>
                    <Col lg={{ size: 8, offset: 2 }} xs="12">
                        <StyledContainer fluid={true}>
                            <h1>KT SUB-STUDY</h1>
                            <hr />
                            <Row>
                                <Col>
                                    <BodyText>
                                        <b>Are you a Pediatric, Adolescent, and Young Adult Cancer Survivor (PAYA-CS) who either completed, started but did not finish, or declined participation in the HIMALAYAS trial?</b>
                                    </BodyText>
                                    <BodyText>
                                        Researchers at the University Health Network in Toronto, Ontario are conducting 45 minute phone interviews to understand the following:
                                    </BodyText>
                                    <ul>
                                        <li><b>For those who completed the study or participated but did not complete the study:</b> People's experiences participating in the study (e.g. what you liked and disliked about the overall intervention and its components; barriers to participating; and what aspects of the intervention helped you achieve your health and fitness goals)</li>
                                        <br />
                                        <li><b>For those who declined the study:</b> People's experiences and impression of the study (e.g. your understanding of the goals of the trial; barriers to participating; and, if and how any aspect of the study can be improved).</li>
                                    </ul>
                                    <BodyText>
                                        If you are interested in having your voice heard, please email <b>Dr. Michelle Nadler, Principal Investigator of Knowledge Translation sub-study, at <a href="mailto:michelle.nadler@uhn.ca">michelle.nadler@uhn.ca</a></b> to learn more about the study.
                                    </BodyText>
                                    <BodyText>
                                        <b>As a token of appreciation, you will receive an Amazon gift card for participating.</b>
                                    </BodyText>
                                </Col>
                            </Row>
                        </StyledContainer>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

const StyledContainer = styled(Container)`
    justify-content: center;
    box-shadow: 0 0.5rem 1rem #372844;
    border-radius: 10px;
    border: solid;
    background-color: white;
    padding: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
`;

const BodyText = styled.p`
    font-size: large;
`;

const StyledBackgroundImage = styled.div`
    width: 100%;
    height: 100%;
    z-index: -1000;
    object-fit: cover;
    position: fixed;
    background-color: #9780af;
`;

const HeightDiv = styled.div`
    height: 100vh;
    position: absolute;
    z-index: -1;
`;

const ParentDiv = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

export default KTSubStudy; 